var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DuoyunCoachMarkElement_instances, _DuoyunCoachMarkElement_tour_get, _DuoyunCoachMarkElement_width_get, _DuoyunCoachMarkElement_skip, _DuoyunCoachMarkElement_open;
// https://spectrum.adobe.com/page/coach-mark/
import { connectStore, adoptedStyle, customElement, attribute, numattribute } from '@mantou/gem/lib/decorators';
import { html } from '@mantou/gem/lib/element';
import { createCSSSheet, css } from '@mantou/gem/lib/utils';
import { createStore, updateStore } from '@mantou/gem/lib/store';
import { splice } from '@mantou/gem/helper/i18n';
import { theme, getSemanticColor } from '../lib/theme';
import { locale } from '../lib/locale';
import { ContextMenu } from './menu';
import { DuoyunVisibleBaseElement } from './base/visible';
import { DuoyunWaitElement } from './wait';
import './card';
import './paragraph';
import './button';
let tourList = [];
const store = createStore({
    currentIndex: 0,
    opened: false,
});
export async function openTour(currentIndex = store.currentIndex) {
    var _a, _b;
    if (!tourList[currentIndex])
        throw new Error('missing tours');
    await ((_b = (_a = tourList[currentIndex]).before) === null || _b === void 0 ? void 0 : _b.call(_a));
    updateStore(store, { opened: true, currentIndex });
}
export async function setTours(tours, options = {}) {
    tourList = Object.assign([], tours);
    const { opened = true, currentIndex = tourList.findIndex((e) => !!e) || 0 } = options;
    if (opened) {
        await openTour(currentIndex);
    }
    else {
        updateStore(store, { opened });
    }
}
async function closeTour() {
    var _a, _b;
    updateStore(store, { opened: false });
    (_b = (_a = tourList[store.currentIndex]).skip) === null || _b === void 0 ? void 0 : _b.call(_a);
}
async function nextTour() {
    var _a, _b;
    updateStore(store, { opened: false });
    ContextMenu.close();
    const { currentIndex } = store;
    const isFinish = currentIndex === tourList.length - 1;
    if (isFinish) {
        updateStore(store, { currentIndex: tourList.findIndex((e) => !!e) || 0 });
    }
    await ((_b = (_a = tourList[currentIndex]).finish) === null || _b === void 0 ? void 0 : _b.call(_a));
    if (!isFinish) {
        openTour(currentIndex + 1);
    }
}
const style = createCSSSheet(css `
  :host {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 3em;
    aspect-ratio: 1;
    border-radius: 10em;
  }
  :host([size='small']) {
    transform: translate(-50%, -50%) scale(0.8);
  }
  :host([size='large']) {
    transform: translate(-50%, -50%) scale(1.2);
  }
  .ring {
    position: absolute;
    inset: 0;
    border-radius: inherit;
    border: 6px solid currentColor;
    opacity: 0;
    transform: scale(1.2);
    animation: glow-grow 2s ease-out infinite;
  }
  .ring:nth-of-type(2) {
    animation-delay: 0.66s;
  }
  .ring:nth-of-type(3) {
    animation-delay: 1.33s;
  }
  @keyframes glow-grow {
    0% {
      opacity: 0;
      transform: scale(0.5);
    }
    66% {
      opacity: 1;
    }
    100% {
      border-width: 2px;
      opacity: 0;
      transform: scale(1);
    }
  }
`);
/**
 * parent element must is relative position
 *
 * @customElement dy-coach-mark
 * @attr index
 * @attr width
 * @attr size
 * @attr color
 */
let DuoyunCoachMarkElement = class DuoyunCoachMarkElement extends DuoyunVisibleBaseElement {
    constructor() {
        super();
        _DuoyunCoachMarkElement_instances.add(this);
        _DuoyunCoachMarkElement_skip.set(this, () => {
            ContextMenu.close();
            closeTour();
        });
        _DuoyunCoachMarkElement_open.set(this, async () => {
            var _a;
            if (!__classPrivateFieldGet(this, _DuoyunCoachMarkElement_instances, "a", _DuoyunCoachMarkElement_tour_get))
                return;
            const { description, preview = '', title, finishText, maskCloseable } = __classPrivateFieldGet(this, _DuoyunCoachMarkElement_instances, "a", _DuoyunCoachMarkElement_tour_get);
            const isFinish = store.currentIndex === tourList.length - 1;
            this.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            if (!this.visibility)
                await new Promise((res) => this.addEventListener('visible', res, { once: true }));
            (_a = DuoyunWaitElement.instance) === null || _a === void 0 ? void 0 : _a.remove(); // avoid inert conflict
            ContextMenu.open(html `
        <dy-card
          style="margin: -0.8em -1em; border: none; border-radius: 0;"
          .header=${title}
          .detailRight=${isFinish
                ? '🎉'
                : splice(locale.currentOfTotal, String(store.currentIndex + 1), String(tourList.length))}
          .preview=${preview}
        >
          <dy-paragraph slot="body">${description}</dy-paragraph>
          <div slot="footer">
            ${isFinish
                ? ''
                : html `<dy-button @click=${() => __classPrivateFieldGet(this, _DuoyunCoachMarkElement_skip, "f").call(this)} small color="cancel">${locale.skipTour}</dy-button>`}
            <dy-button @click=${() => nextTour()} small>
              ${finishText || (isFinish ? locale.finishTour : locale.nextTour)}
            </dy-button>
          </div>
        </dy-card>
      `, {
                maskCloseable,
                activeElement: this,
                width: __classPrivateFieldGet(this, _DuoyunCoachMarkElement_instances, "a", _DuoyunCoachMarkElement_width_get),
            }).then(() => {
                closeTour();
            });
        });
        this.mounted = () => {
            this.effect(() => {
                if (__classPrivateFieldGet(this, _DuoyunCoachMarkElement_instances, "a", _DuoyunCoachMarkElement_tour_get)) {
                    __classPrivateFieldGet(this, _DuoyunCoachMarkElement_open, "f").call(this);
                }
            });
        };
        this.render = () => {
            if (!__classPrivateFieldGet(this, _DuoyunCoachMarkElement_instances, "a", _DuoyunCoachMarkElement_tour_get)) {
                return html `
        <style>
          :host {
            display: none;
          }
        </style>
      `;
            }
            return html `
      <style>
        :host {
          color: ${getSemanticColor(this.color) || this.color || theme.informativeColor};
        }
      </style>
      <span class="ring"></span>
      <span class="ring"></span>
      <span class="ring"></span>
    `;
        };
        this.addEventListener('pointerdown', (e) => e.stopPropagation());
        this.addEventListener('pointerup', (e) => e.stopPropagation());
        this.addEventListener('click', (e) => e.stopPropagation());
    }
};
_DuoyunCoachMarkElement_skip = new WeakMap(), _DuoyunCoachMarkElement_open = new WeakMap(), _DuoyunCoachMarkElement_instances = new WeakSet(), _DuoyunCoachMarkElement_tour_get = function _DuoyunCoachMarkElement_tour_get() {
    return this.index === store.currentIndex && store.opened && tourList[this.index];
}, _DuoyunCoachMarkElement_width_get = function _DuoyunCoachMarkElement_width_get() {
    return this.width || '16em';
};
__decorate([
    numattribute
], DuoyunCoachMarkElement.prototype, "index", void 0);
__decorate([
    attribute
], DuoyunCoachMarkElement.prototype, "width", void 0);
__decorate([
    attribute
], DuoyunCoachMarkElement.prototype, "size", void 0);
__decorate([
    attribute
], DuoyunCoachMarkElement.prototype, "color", void 0);
DuoyunCoachMarkElement = __decorate([
    customElement('dy-coach-mark'),
    adoptedStyle(style),
    connectStore(store),
    connectStore(locale)
], DuoyunCoachMarkElement);
export { DuoyunCoachMarkElement };
//# sourceMappingURL=coach-mark.js.map